module.exports = __webpack_public_path__ + "static/media/introduce_p5@2x.b22f757b.png";